export default {
  // Header
  header: {
    title: 'BIDV Secure Prepaid Card',
    welcome: 'Welcome',
    logout: 'Logout',
    language: 'Language',
    profile: 'Profile',
    menu: 'Menu'
  },

  // Navigation
  nav: {
    dashboard: 'Dashboard',
    cardInfo: 'Card Information',
    activateCard: 'Activate Card',
    changePin: 'Change PIN',
    lockUnlock: 'Lock/Unlock Card',
    transactions: 'Transaction History',
    reports: 'Access Reports',
    features: 'Feature Management'
  },

  // Common
  common: {
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    search: 'Search',
    filter: 'Filter',
    refresh: 'Refresh',
    loading: 'Loading...',
    noData: 'No data available',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Information',
    current: 'Current',
    featureUnavailable: 'Feature temporarily unavailable',
    technicalSupport: 'Technical Support',
    processing: 'Processing...',
    reset: 'Reset',
    retry: 'Retry'
  },

  // Error Codes
  errorCodes: {
    E101: 'Invalid card status',
    E102: 'Invalid card information',
    E103: 'Invalid card product',
    E104: 'Verification has expired. Please try again',
    E105: 'Card has expired',
    E106: 'No results found',
    E107: 'Token has expired',
    E108: 'Invalid token',
    E109: 'Invalid card account',
    E110: 'Invalid card status',
    E111: 'Invalid production status',
    7006: 'No transaction data found in the selected time range',
    LockCardFailed: 'Lock card failed',
    UnlockCardFailed: 'Unlock card failed'
  },

  // Authentication
  auth: {
    login: 'Login',
    logout: 'Logout',
    username: 'Username',
    password: 'Password',
    usernamePlaceholder: 'Enter username',
    passwordPlaceholder: 'Enter password',
    forgotPassword: 'Forgot Password?',
    loginFailed: 'Login Failed',
    invalidCredentials: 'Invalid credentials',
    sessionExpired: 'Session expired',
    captcha: 'Verification Code',
    captchaRefresh: 'Click to refresh verification code',
    captchaInput: 'Enter verification code',
    captchaHelper: 'Enter 6 characters from the image above',
    captchaPlaceholder: 'Enter code from image',
    cardId: 'Card ID',
    expiryDate: 'Expiry Date (MMYY)',
    iframeError: 'Iframe loading error',
    loadingLoginForm: 'Loading login form...'
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    welcomeMessage: 'Welcome to BIDV Secure Prepaid Card Management System',
    cardStatus: 'Card Status',
    balance: 'Balance',
    currentBalance: 'Current Balance',
    availableLimit: 'Available Limit',
    recentTransactions: 'Recent Transactions',
    quickActions: 'Quick Actions',
    systemStatus: 'System Status'
  },

  // Card Management
  card: {
    lockCardSuccess: 'Card locked successfully',
    unlockCardSuccess: 'Card unlocked successfully',
    lockCardPending: 'Card is being locked',
    unlockCardPending: 'Card is being unlocked',
    lockCard: 'Lock Card',
    unlockCard: 'Unlock Card',
    titleCardInfo: 'Card Information',
    cardNumber: 'Card Number',
    cardId: 'Card ID',
    cardHolder: 'Card Holder',
    expiryDate: 'Expiry Date',
    cvv: 'CVV',
    pin: 'PIN',
    status: 'Status',
    balance: 'Balance',
    dailyLimit: 'Daily Limit',
    monthlyLimit: 'Monthly Limit',
    activate: 'Activate',
    deactivate: 'Deactivate',
    lock: 'Lock Card',
    unlock: 'Unlock Card',
    changePin: 'Change PIN',
    currentPin: 'Current PIN',
    newPin: 'New PIN',
    confirmPin: 'Confirm PIN',
    productType: 'Card Product Type',
    lockUnlockMaintenanceMessage: 'Card lock/unlock feature is under maintenance. Please try again later.',
    // New keys for CardInfo component
    basicInfo: 'Basic Information',
    cardStatus: 'Card Status',
    financialInfo: 'Financial Information',
    timeInfo: 'Time Information',
    currentBalance: 'Current Balance',
    blockedAmount: 'Blocked Amount',
    availableLimit: 'Available Limit',
    embossingName: 'Embossing Name',
    contractBranch: 'Contract Branch',
    productionStatus: 'Production Status',
    activationStatus: 'Activation Status',
    activated: 'Activated',
    notActivated: 'Not Activated',
    cvv2: 'CVV2 Number',
    issueDate: 'Issue Date',
    cardDetails: 'Card Details',
    viewCardDetails: 'View detailed information about your prepaid card',
    securityNotice: 'Notice',
    securityNoticeDescription: 'Please note security and do not share PIN with anyone.',

    visaPrepaidNonKYC: 'Visa Prepaid Non-KYC',
    napasPrepaidNonKYC: 'NAPAS Prepaid Non-KYC',
    // New keys for ChangePin component
    changePinTitle: 'Set/Change PIN',
    changePinDescription: 'Change PIN to secure your card',
    cardInfoTitle: 'Card Information',
    cardNumberLabel: 'Card Number',
    cardStatusLabel: 'Card Status',
    productionStatusLabel: 'Activation Status',
    expiryDateLabel: 'Expiry Date',
    newPinInfoTitle: 'New PIN Information',
    newPinLabel: 'New PIN',
    newPinHelperText: 'Enter 6-digit new PIN',
    newPinPlaceholder: '000000',
    confirmPinLabel: 'Re-enter new PIN',
    confirmPinHelperText: 'Re-enter new PIN to confirm',
    confirmPinPlaceholder: '000000',
    changePinButton: 'Change PIN',
    changePinWarningTitle: 'PIN Change Notes',
    changePinWarningDescription: '• PIN must have exactly 6 numeric characters',
    changePinWarningDescription2: '• Please note security and do not share PIN with anyone',
    // New keys for LockUnlockCard component
    lockUnlockTitle: 'Lock/Unlock Card',
    lockUnlockDescription: 'Manage card operational status',
    confirmLockTitle: 'Confirm Card Lock',
    confirmLockContent: 'Are you sure you want to lock the card? The card will not be usable until unlocked.',
    confirmUnlockTitle: 'Confirm Card Unlock',
    confirmUnlockContent: 'Are you sure you want to unlock the card? The card will be usable normally.',
    // New keys for ActivateCard component
    activateCardTitle: 'Activate Card',
    activateCardInfo: 'Click the button below to activate your card',
    // New keys for LockUnlockCard component
    cardOperationsTitle: 'Lock/Unlock Card',
    lockUnlockWarningTitle: 'Important Notes',
    lockUnlockWarningDescription: '• Lock card when lost, stolen, or suspected security issues\n• Unlock card when found or confirmed no security issues\n• Locked cards cannot perform any transactions\n• For emergency support, contact: 1900 9247',
    // Confirm dialog texts
    confirmLockTitleShort: 'Lock Card',
    confirmUnlockTitleShort: 'Unlock Card',
    confirmLockMessageWithCard: 'Are you sure you want to lock card {{cardNumber}}?',
    confirmUnlockMessageWithCard: 'Are you sure you want to unlock card {{cardNumber}}?'
  },

  // Transactions
  transactions: {
    titleItem: 'Look up transaction history',
    title: 'Transaction History',
    date: 'Date',
    time: 'Time',
    amount: 'Original transaction amount',
    amountVND: 'Transaction Amount (VND)',
    type: 'Transaction Type',
    merchant: 'Merchant',
    location: 'Location',
    status: 'Status',
    reference: 'Reference',
    description: 'Description',
    balance: 'Balance After Transaction',
    filterByDate: 'Filter by Date',
    filterByType: 'Filter by Type',
    filterByAmount: 'Filter by Amount',
    export: 'Export Data',
    maintenanceMessage: 'Transaction history feature is under maintenance. Please try again later.',
    // New keys for TransactionHistory component
    error: {
      selectTimeRange: 'Please select time range',
      startDateGreaterThanEndDate: 'Start date cannot be greater than end date',
      maxTimeRange: 'Maximum time range is 30 days',
      startDateGreaterThan12Months: 'The maximum query time is 12 months from the date of transaction.'
    },
    noDataFound: 'No transaction data found in the selected time range',
    systemTemporarilyUnavailable: 'System is temporarily unavailable, please try again later.',
    // Additional keys for complete translation
    selectTimeRange: 'Select transaction time range:',
    fromDate: 'From Date',
    toDate: 'To Date',
    search: 'Search',
    searching: 'Searching...',
    reset: 'Reset',
    searchResults: 'Search Results ({{count}} transactions)',
    transactionTime: 'Transaction Time',
    cardNumber: 'Card Number',
    vndAmount: 'Balance',
    fee: 'Fee',
    transactionCode: 'Transaction Code',
    postingDate: 'Posting Date',
    authCode: 'Auth Code',
    note: 'Note: Search for all card transaction types within the last 30 days',
    endOfResults: 'All transactions displayed',
    loaded: 'transactions loaded',
    pleaseSelectTimeRangeAndSearch: 'Please select time range and click "Search" to view transaction history'
  },

  // Messages
  messages: {
    cardActivated: 'Card activated successfully',
    cardDeactivated: 'Card deactivated successfully',
    pinChanged: 'PIN changed successfully',
    cardLocked: 'Card locked successfully',
    cardUnlocked: 'Card unlocked successfully',
    operationSuccess: 'Operation completed successfully',
    operationFailed: 'Operation failed',
    confirmDelete: 'Are you sure you want to delete?',
    confirmAction: 'Are you sure you want to perform this action?',
    unsavedChanges: 'You have unsaved changes. Do you want to leave the page?'
  },

  // Status
  status: {
    active: 'Active',
    inactive: 'Inactive',
    locked: 'Locked',
    unlocked: 'Unlocked',
    pending: 'Pending',
    completed: 'Completed',
    failed: 'Failed',
    cancelled: 'Cancelled',
    processing: 'Processing'
  },

  // Validation
  validation: {
    required: 'This field is required',
    invalidFormat: 'Invalid format',
    invalidPin: 'PIN must be 6 digits',
    pinMismatch: 'PINs do not match',
    minLength: 'Minimum length is {min} characters',
    maxLength: 'Maximum length is {max} characters',
    email: 'Invalid email format',
    phone: 'Invalid phone number format',
    captchaRequired: 'Please verify the captcha'
  },


};
